import React, { useState } from 'react'
import { Row, Col } from 'antd'
import { IconHelper, connectApproveUser, Reject } from "./../../helpers"
import ModalEditParticipant from './ModalEditParticipant';
import { translate } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { checkTokenExpire } from './../../redux/actions/actions'

const Header = ({ t, userInfo, handleChatApi, realtimeAPI }) => {
    
    const { IconEditParticipant, IconUserChecked, IconInside, IconCloseGray } = IconHelper
    const dispatch = useDispatch()
  

    const [editParticipant, setEditParticipant] = useState(false)
    const ChangeParticipant = (u) => {
        dispatch(checkTokenExpire)
        setEditParticipant(!editParticipant)
       
    }
    
    return (
        <>
            <Row className="reservation-content-header">
                <Col xl={13} lg={8} md={24} style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="text-participant-name">
                        {userInfo.isMember ? <IconUserChecked /> : <div style={{ width: 20 }} />}
                        {userInfo.isMember && ( <>&nbsp;</>)} {userInfo.name}
                    </div>
                    <div className="text-participant-id">@{userInfo.chatUserID}
                        <IconEditParticipant onClick={ChangeParticipant.bind(this,userInfo.name)} style={{
                            margin: '6px',
                            marginLeft: "10px",
                            cursor: 'pointer'
                        }} /></div>

                </Col>
                <Col xl={11} lg={16} md={24} className="reservation-content-header-right">
                    
                    <IconInside
                        className="iconLeft"
                        width={22}
                        height={22}
                        onClick={connectApproveUser.bind(this, userInfo.id)}
                        style={{
                            position: "absolute",
                            left: "70%",
                            cursor: 'pointer'
                        }}
                    />
                    
                    
                    {/* <IconLive
                        style={{
                            position: "absolute",
                            left: "80%",
                            cursor: 'pointer'
                        }}
                    /> */}
                    <IconCloseGray
                        className="iconReject"
                        width={22}
                        height={22}
                        onClick={Reject.bind(this, userInfo)}
                        style={{
                            position: "absolute",
                            left: "80%",
                            cursor: 'pointer'
                        }}
                    />
                </Col>
            </Row>
            <ModalEditParticipant
                userInfo={userInfo}
                handleChatApi={handleChatApi}
                visible={editParticipant}
                title={t("lobby_modal.header")}
                setEditParticipant={setEditParticipant}
                realtimeAPI={realtimeAPI}
                
            />
        </>
    )
}

export default translate()(Header)
